import React from "react";
import { Container } from "shards-react";

import Drawer from "../Drawer";
const DefaultLayout = ({ children }) => (
  <Container fluid style={{ padding: "0px" }}>
   
   
    <Drawer children={children} />
   
  </Container>
);

export default DefaultLayout;
